"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _HelperText = _interopRequireDefault(require("../HelperText"));

var _Select = _interopRequireDefault(require("./Select.sizes"));

var _Select2 = _interopRequireDefault(require("./Select.theme"));

var _styles = require("./styles");

var _excluded = ["autoComplete", "bgColor", "className", "color", "options", "floatingMessage", "id", "label", "leftIcon", "maxLength", "message", "name", "onBlur", "onFocus", "onChange", "onSelectOption", "rightIcon", "size", "status", "textarea", "textColor", "type", "theme", "style"];
var Select = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _selectThemeSizes$siz;

  var autoComplete = _ref.autoComplete,
      bgColor = _ref.bgColor,
      className = _ref.className,
      color = _ref.color,
      optionsProp = _ref.options,
      floatingMessage = _ref.floatingMessage,
      id = _ref.id,
      label = _ref.label,
      leftIcon = _ref.leftIcon,
      maxLength = _ref.maxLength,
      message = _ref.message,
      name = _ref.name,
      _onBlur = _ref.onBlur,
      _onFocus = _ref.onFocus,
      _onChange = _ref.onChange,
      onSelectOption = _ref.onSelectOption,
      rightIcon = _ref.rightIcon,
      size = _ref.size,
      status = _ref.status,
      textarea = _ref.textarea,
      textColor = _ref.textColor,
      type = _ref.type,
      theme = _ref.theme,
      style = _ref.style,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var selectThemeSizes = (0, _Select.default)(theme);
  var selectSize = (_selectThemeSizes$siz = selectThemeSizes[size]) !== null && _selectThemeSizes$siz !== void 0 ? _selectThemeSizes$siz : selectThemeSizes[theme.sizes.input];
  var selectColors = {
    background: theme.colors[bgColor],
    color: theme.colors[color],
    textColor: theme.colors[textColor],
    primary: theme.colors.primary,
    danger: theme.colors.danger,
    success: theme.colors.success
  };
  var appearance = (0, _Select2.default)(selectColors);
  var inputId = id || name;
  var fieldClassNames = [];

  if (status) {
    fieldClassNames.push("has-".concat(status));
  }

  if (leftIcon) {
    fieldClassNames.push("with-left-icon");
  }

  if (textarea) {
    fieldClassNames.push("textarea");
  }

  var options = optionsProp.map(function (obj, key) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: key,
      value: obj.value
    }, obj.name);
  });
  return /*#__PURE__*/_react.default.createElement(_styles.GenericDiv, {
    className: className,
    tabIndex: "1",
    style: style
  }, /*#__PURE__*/_react.default.createElement(_styles.Field, {
    appearance: appearance,
    size: selectSize,
    className: fieldClassNames.join(' '),
    bgColor: bgColor
  }, /*#__PURE__*/_react.default.createElement(_styles.FieldInput, Object.assign({
    appearance: appearance,
    as: 'select',
    ref: ref,
    id: inputId,
    name: name,
    type: type,
    placeholder: " ",
    autoComplete: autoComplete,
    maxLength: maxLength,
    onFocus: function onFocus(event) {
      if (_onFocus) _onFocus(event);
    },
    onBlur: function onBlur(event) {
      if (_onBlur) _onBlur(event);
    },
    onChange: function onChange(event) {
      if (_onChange) _onChange(event);
    }
  }, rest, {
    "aria-invalid": status === 'error'
  }), options), /*#__PURE__*/_react.default.createElement(_styles.Notched, null, /*#__PURE__*/_react.default.createElement(_styles.NotchedLeading, null), /*#__PURE__*/_react.default.createElement(_styles.NotchedNotch, null, /*#__PURE__*/_react.default.createElement(_styles.Label, {
    htmlFor: inputId
  }, label)), /*#__PURE__*/_react.default.createElement(_styles.NotchedTrailing, null)), leftIcon && /*#__PURE__*/_react.default.createElement(_styles.FieldIcon, null, leftIcon)), /*#__PURE__*/_react.default.createElement(_HelperText.default, {
    status: status,
    message: message,
    floating: floatingMessage
  }));
});
Select.displayName = 'Select';
Select.defaultProps = {
  id: undefined,
  className: '',
  label: 'Informe um label',
  type: 'text',
  autoComplete: 'off',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onSelectOption: function onSelectOption() {},
  floatingMessage: false,
  status: 'neutral600',
  color: 'neutral400',
  bgColor: 'ghost',
  textColor: 'neutral950'
};

var _default = (0, _styledComponents.withTheme)(Select);

exports.default = _default;